
import { ETHNOPORTAL_URL } from 'PortalDir/constants/app/common';
import { computed, defineComponent } from 'vue';

export default defineComponent({
  setup() {
    const getIframeUrl = computed(() => `${ETHNOPORTAL_URL}/proxy-language-center-corpus`);

    const redirectToEthnoportal = () => {
      window.open(ETHNOPORTAL_URL, '_blank');
    };

    return {
      getIframeUrl,

      redirectToEthnoportal
    };
  },
});
